import instance from "./endpoint";

// get profile
export const getProfile = async () => {
    const response = await instance.get("api/v1/admin/auth/profile", {});
    return response.data;
};

// update admin profile fullname
export const updateProfile = async ({ FullName }) => {
    return await instance.put("/api/v1/admin/auth/profile", {FullName});
};

// api to update password
export const changePassword = async ({ oldPassword, newPassword }) => {
    try {
      const response = await instance.put("/api/v1/admin/auth/changePassword", {
        oldPassword,
        newPassword,
      });
      return response.data;
    } catch (error) {
      console.error("Error changing password:", error);
      throw error;
    }
  };

// get kyc docs
export const getKycDocs = async () => {
    const response = await instance.get("/api/v1/kycproof/getSomeKycProofs");
    return response.data;
};

// get all users
export const getAllUsers = async () => {
    const response = await instance.get("api/v1/admin/control/getAllUsers");
    return response.data;
};

// get all deposit requests
export const getalldepositReq = async () => {
    const response = await instance.get("/api/v1/deposit/getSomeDepositReq");
    return response.data;
};

//get all withdraw requests
export const getallwithdrawReq = async () => {
    const response = await instance.get("/api/v1/withdraw/getSomeWithdrawalReq");
    return response.data;
};


// send kyc email api
export const sendMailToUser = async (AccountID, Email, Message) => {
    const response = await instance.post("/api/v1/kycproof/sendkycEmail", { AccountID, Email, Message });
    return response.data;
}; 

// Delete Admin (for SuperAdmin role)
export const deleteAdmin = async (AdminID) => {
  try {
    const response = await instance.patch("/api/v1/admin/auth/deleteAdmin",{
    AdminID,
  });
    // console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting admin:", error);
    throw error;
  }
};


// Get all Referrals (admin)
export const getAllReferrals = async () => {
    try {
        const response = await instance.get("/api/v1/referrals/fetchSomeReferrals");
        return response.data;
    } catch (error) {
        console.error("Error fetching referrals:", error);
        throw error;
    }
};

//get all loan agreements (admin and superadmin)
export const getSpecificLoanAgreements = async () => {
    try {
        const response = await instance.get("api/v1/generateDoc/specificloanagreements");
        return response.data;
    } catch (error) {
        console.error("Error fetching loan agreements:", error);
        throw error;
    }
};
